import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Field from "../Field";

interface InviteUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedUserLabel: string;
  userSearchText: string;
  setSelectedUserLabel: (value: string) => void;
  userSearchList: any[];
  userDropdown: boolean;
  setUserDropdown: (open: boolean) => void;
  setSelectedUserId: (id: number | null) => void;
  setUserSearchText: (value: string) => void;
  selectedUserId: number | null;
  loading: boolean;
  onSearch: (value: string) => void;
  onSend: () => void;
}

const InviteUserDialog: React.FC<InviteUserDialogProps> = ({
  open,
  onOpenChange,
  selectedUserLabel,
  userSearchText,
  setSelectedUserLabel,
  userSearchList,
  userDropdown,
  setUserDropdown,
  setSelectedUserId,
  selectedUserId,
  loading,
  onSearch,
  onSend,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Oyunçu dəvət et</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <Field label="Oyunçu seçin">
          <div className="relative">
            <Input
              placeholder="İstifadəçi adı ilə axtarın"
              value={selectedUserLabel || userSearchText}
              onChange={(e) => {
                setSelectedUserLabel("");
                onSearch(e.target.value);
              }}
              onFocus={() => userSearchList.length > 0 && setUserDropdown(true)}
              onBlur={() => setTimeout(() => setUserDropdown(false), 150)}
            />
            {userDropdown && userSearchList.length > 0 && (
              <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden max-h-52 overflow-y-auto">
                {userSearchList.map((u: any) => (
                  <button
                    key={u.id}
                    type="button"
                    className="w-full px-3 py-2.5 text-left text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                    onClick={() => {
                      setSelectedUserId(u.id);
                      setSelectedUserLabel(`${u.name} ${u.surname}`);
                      setUserDropdown(false);
                    }}
                  >
                    {u.name} {u.surname}
                  </button>
                ))}
              </div>
            )}
          </div>
        </Field>
        <Button onClick={onSend} disabled={loading || !selectedUserId} className="w-full">
          Dəvət göndər
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default InviteUserDialog;
